import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  width: 26px;
  transition: all 0.25s ease-in-out;
  border-radius: 6px;
  display: none;

  &&.tight {
    background-color: ${({ theme }) => theme.editor.backgroundLight};
    height: 100%;
    padding: 0 3px;

    && > .zoom-icon {
      justify-content: center;

      svg path {
        fill: ${({ theme }) => theme.editor.textLight};
      }
    }

    .ant-popover-inner-content {
      padding: 0;
    }
  }

  &&.thicc {
    overflow-x: clip;
    color: ${({ theme }) => theme.editor.textMedium};

    && > .zoom-icon {
      margin-left: 3px;
    }

    &&:hover {
      width: 181px;
      overflow-x: visible;
      color: ${({ theme }) => theme.editor.textLight};
    }

    &&.active {
      display: flex;
      width: 181px;
      overflow-x: visible;
    }
  }
`;

export const ZoomIcon = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  width: 22px;
  transition: all 0.25s ease-in-out;

  && > svg path {
    fill: ${({ theme }) => theme.editor.textMedium};
  }
`;

export const SliderRailingContainer = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.editor.backgroundLight};
  height: 100%;
  top: 0;
  width: 100%;
  z-index: 0;
  border-radius: 20px;
  overflow: hidden;
`;

export const ZoomContainer = styled.div`
  display: none;
  flex: 1;
  gap: 5px;
  align-items: center;

  &&.active {
    display: flex;
  }
`;

export const ZoomButtons = styled.div`
  display: flex;
  gap: 7px;
  justify-content: flex-start;
  align-items: center;
  & > div {
    color: white;
    background-color: ${props => props.theme.highlight};
    border-radius: 6px;
    height: 26px;
    width: 25px;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
  }
`;
